<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebar-logo-fade">
      <div class="sidebar-logo-link" v-if="collapse">
        <div class="flex-column flex-y-center" v-if="logoMini">
          <img :src="logoMini" class="sidebar-logo mini-logo" alt="" />
          <span>{{ title }}</span>
        </div>
        <h1 v-else class="sidebar-title">
          {{ title }}
        </h1>
      </div>
      <div class="sidebar-logo-link" v-else>
        <div class="flex-column flex-y-center" v-if="logo">
          <img src="../../../../common/assets/images/srm-logo.png" class="sidebar-logo" alt="" />
          <span>{{ title }}</span>
        </div>

        <h1 v-else class="sidebar-title">
          {{ title }}
        </h1>
      </div>

      <!-- </router-link> -->
    </transition>
  </div>
</template>

<script>
  import useAssets from '@main/common/assets/useAssets.js'
  import logoImgMini from '@main/common/assets/images/srm-logo.png'
  // import logoImgMini from '@main/common/assets/images/logo.png'

  export default {
    name: 'SidebarLogo',
    props: {
      collapse: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        useAssets,
        title: '供应商系统',
        logo: logoImgMini,
        logoMini: logoImgMini
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sidebar-logo-fade-enter-active {
    transition: opacity 1.5s;
  }

  .sidebar-logo-fade-enter,
  .sidebar-logo-fade-leave-to {
    opacity: 0;
  }

  .flex-column {
    display: flex;
    flex-direction: column;

    span {
      font-size: 12px;
      line-height: 35px;
      flex: 1;
      width: 100%;
    }
  }

  .sidebar-logo-container {
    line-height: 56px;
    position: relative;
    overflow: hidden;
    width: 220px;
    height: 56px;
    text-align: center;

    & .sidebar-logo-link {
      width: 100%;
      height: 100%;
      border-bottom: 1px solid rgb(255 255 255 / 20%);

      & .sidebar-logo {
        height: 20px;
        margin-top: 5px;
      }

      & .sidebar-logo.mini-logo {
        position: relative;
        left: -10px;
        height: 16px;
      }

      & .sidebar-title {
        font-family: 'Avenir', 'Helvetica Neue', 'Arial', 'Helvetica', sans-serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 50px;
        display: inline-block;
        margin: 0;
        vertical-align: middle;
        color: #fff;
      }
    }

    &.collapse {
      .sidebar-logo {
        margin-right: 0;
      }
    }
  }
</style>
